import { getEmployeeProfilePath } from './employee-href';
import { extractEmail, extractUrl } from './employee-contact';
import { getEmployeePhotoSrc } from './employee-photo-src';
import { createPersonSchema, employeeSchemaId } from './schema';

/**
 * Map WP ansatte nodes to schema.org Person objects.
 *
 * @param {Array<object>} employees
 * @param {'no'|'en'} [languageCode='no']
 * @returns {Array<object>}
 */
export function mapEmployeesToPersonSchemas(employees = [], languageCode = 'no') {
  return (employees || [])
    .filter((employee) => employee?.title && employee?.slug)
    .map((employee) => {
      const linkedin = extractUrl(employee.ansatte?.linkedin);
      const photoNode = employee.ansatte?.employeePhoto?.node;
      return createPersonSchema({
        name: employee.title,
        url: getEmployeeProfilePath(employee, languageCode),
        id: employeeSchemaId(employee.slug, languageCode),
        jobTitle: employee.ansatte?.role,
        email: extractEmail(employee.ansatte?.email),
        imageUrl: photoNode ? getEmployeePhotoSrc(photoNode, 400) : undefined,
        sameAs: linkedin ? [linkedin] : [],
      });
    });
}
